export default {
      id: "oc-hcsop-usage",
      viewBox: "0 0 1382 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-hcsop",
      toString: function () {
        return this.url;
      }
    }